import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { ArrowUp } from "lucide-react";
import { AnimatedNotes } from "@/components/AnimatedNotes";

export const FloatingTopArrow = () => {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 500);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return (
    <button
      type="button"
      aria-label="Back to top"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      data-testid="floating-top-arrow"
      className={`fixed bottom-6 right-6 z-50 flex h-12 w-12 items-center justify-center rounded-full bg-primary text-primary-foreground shadow-xl transition-[opacity,transform] duration-300 hover:scale-110 ${show ? "opacity-100" : "pointer-events-none translate-y-4 opacity-0"}`}
    >
      <ArrowUp size={20} />
    </button>
  );
};

export const GlobalNotes = () => {
  const { pathname } = useLocation();
  if (pathname === "/" || pathname === "/live" || document.documentElement.classList.contains("a11y-reduce-motion")) return null;
  return (
    <div className="pointer-events-none fixed inset-0 -z-10" data-testid="global-floating-notes">
      <AnimatedNotes count={16} spread />
    </div>
  );
};
